import { useSyncExternalStore } from 'react'
import { TPortalState } from '../../../types/state'
import { LayoutEvent } from '../../constants/enums'
import { LAYOUTSTATE } from '../../state'
import { pubSubLayout } from '../../state/pubSub'

const subPortal = (callback) =>
    pubSubLayout.on(LayoutEvent.PORTAL_CHANGE, callback)
const getPortalSelector = (attribute) => () => LAYOUTSTATE.portal[attribute]

export const usePortalStateSelector = <T extends keyof TPortalState>(
    attribute: T,
): TPortalState[T] => {
    return useSyncExternalStore(
        subPortal,
        getPortalSelector(attribute),
        getPortalSelector(attribute),
    )
}
